import { createReduxSagaActionSubtypes as createSubtypes } from '@/utils/create-redux-saga-action-subtypes';

export const SalesRepActionTypes = {
  MARK_AS_SELECTED: 'salesRep|markAsSelected',
  CREATE_NEW: createSubtypes('salesRep|createNew'),
  FETCH_ALL: createSubtypes('salesRep|fetchAll'),
  UPDATE_CONTACT_INFO: createSubtypes('salesRep|updateContactInfo'),
};
